import importerStore from '@shared/importer/importer-store';
import { CommentService } from '@modules/comment/comment-service';
import commentImporterFields from '@modules/comment/comment-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  CommentService.import,
  commentImporterFields,
  i18n('entities.comment.importer.fileName'),
  i18n('entities.comment.importer.hint'),
);
